import { useAppState } from '../useAppState';

export const useEmployeeEditorState = () => {
  const { employeeEditorState } = useAppState();

  return employeeEditorState;
};
